import API from './config';

export const ReportAPI = {
    async getFullReport(client, paths, isCustomReport, customReportName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/fullReport', {
                client: client,
                paths: paths,
                is_custom_report: isCustomReport,
                custom_report_name: customReportName,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getPortfolioReport(client, period, data, extraPortfolioReportParams, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/portfolioReport', {
                client: client,
                period: period,
                data: data,
                extra_portfolio_report_params: extraPortfolioReportParams,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getProvisionalReport(client, period, data, page) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/provisionalReport', {
                client: client,
                period: period,
                data: data,
                page: page,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundsRankingReport(client, period, data, page, filters) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/fundsRankingReport', {
                client,
                period,
                data,
                page,
                filters,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getDemonstrativeReport(client, period, data) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/demonstrativeReport', {
                client,
                period,
                data
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFullDemonstrativeReport(client, resultPaths, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/fullDemonstrativeReport', {
                client: client,
                resultPaths: resultPaths,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getDistribuitionReportPart(client, period, data, index, page) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/distribuitionReportPart', {
                client: client,
                period: period,
                data: data,
                index: index,
                page: page,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getDistribuitionReportPartGrouped(client, period, data1, data2, index1, index2, page) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/getDistribuitionReportPartGrouped', {
                client: client,
                period: period,
                data1: data1,
                data2: data2,
                index1,
                index2,
                page: page,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getDistribuitionReport(client, resultPaths, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/distribuitionReport', {
                client: client,
                resultPaths: resultPaths,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAprBatchReport(client, resultPaths) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/batchAprsReport', {
                client: client,
                resultPaths: resultPaths,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error?.response?.data ?? { message: error.message }
            };
        }

    },

    async getCompareFundsReport(client, funds, benchmarks, tablesData, returnsTableData) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/fundsCompareReport', {
                client: client,
                tablesData: tablesData,
                returnsTableData: returnsTableData,
                funds: funds,
                benchmarks: benchmarks
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAprReport(client, transaction) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            // console.log("APR PAYLOAD: ", JSON.stringify({
            //     client: client,
            //     transaction: transaction
            // }));

            const response = await API.post('/reports/aprReport', {
                client: client,
                transaction: transaction
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error?.response?.data ?? { message: error.message }
            };
        }

    },

    async getSingleAprReport(client, transaction) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/singleAprReport', {
                client: client,
                transaction: transaction
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getArticlesReport(client, data, period, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/articlesReport', {
                client: client,
                data: data,
                period: period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getArticlesV2Report(client, data, period, capaFileName, distributionByDevice) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/articlesReportV2', {
                client: client,
                data: data,
                period: period,
                capaFileName,
                distributionByDevice
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getTargetsReport(client, period, data, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/targetsReport', {
                client: client,
                data: data,
                period: period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getDashboardReport(client, period, data, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/dashboardReport', {
                client: client,
                data: data,
                period: period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getCapaReport(client, period, title, subTitle) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/capaReport', {
                client: client,
                period: period,
                title: title,
                sub_title: subTitle
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getIPC14ReturnsReport(client, data) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/ipca14ReturnsReport', {
                client: client,
                data: data,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getLossProvisionReport(client, data) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/lossProvisionReport', {
                client: client,
                data: data,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getBladeFundReport(client, data, referenceDate, fileNameReturnsReport, fileNamePlReport) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/bladeFundReport', {
                client: client,
                data: data,
                referenceDate: referenceDate,
                fileNameReturnsReport, fileNamePlReport
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAlmReport(client, period, data) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/almReport', {
                client: client,
                data: data,
                period: period,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getRentsByClassReport(client, period, data, fileNameRentsByClassChart, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/rentsByClassReport', {
                client: client,
                data: data,
                period: period,
                fileNameRentsByClassChart: fileNameRentsByClassChart,
                capaFileName: capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAlocationReport(client, capaFileName, data, referenceDate, fileNameBenchmarkReport) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/alocationReport', {
                client: client,
                data: data,
                capaFileName: capaFileName,
                referenceDate: referenceDate,
                fileNameBenchmarkReport
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getMyFundsReport(client, period, data, periodReport, monthsPeriod, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/myFundsReport', {
                client: client,
                data: data,
                period: period,
                period_report: periodReport,
                months_period: monthsPeriod,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getMyTitlesReport(client, period, data, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/myTitlesReport', {
                client: client,
                data: data,
                period: period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getMyReturnsReport(client, period, data, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/myReturnsReport', {
                client,
                data,
                period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getMyGlobalReturnsReport(client, period, data, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/myGlobalReturnsReport', {
                client,
                data,
                period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getMyReturnsByAssetsReport(client, period, data, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/myReturnsByAssetsReport', {
                client,
                data,
                period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAccreditationProcessesReport(client, period, data, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/accreditationProcessesReport', {
                client,
                data,
                period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getMyReturnsByArticlesReport(client, period, data, capaFileName) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            const response = await API.post('/reports/myReturnsByArticlesReport', {
                client,
                data,
                period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {
            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getMyReturnsBySegregationReport(client, period, data, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/myReturnsBySegregationReport', {
                client,
                data,
                period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getBenchmarkIndexesReport(client, period, data, capaFileName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/benchmarkIndexesReport', {
                client,
                data,
                period,
                capaFileName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getSuitabilityReport(client, currentSuitability, suitabilityResponses) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            console.log("XXX: ", client, currentSuitability, suitabilityResponses);

            const response1 = await API.post('/reports/suitabilityReport1', {
                client,
                current_suitability: currentSuitability,
                suitability_responses: suitabilityResponses
            }, config)

            const response2 = await API.post('/reports/suitabilityReport2', {
                client,
                current_suitability: currentSuitability,
                suitability_responses: suitabilityResponses
            }, config)

            const response3 = await API.post('/reports/suitabilityReport3', {
                client,
                current_suitability: currentSuitability,
                suitability_responses: suitabilityResponses
            }, config)

            const response4 = await API.post('/reports/suitabilityReport4', {
                client,
                current_suitability: currentSuitability,
                suitability_responses: suitabilityResponses
            }, config)

            //console.log("Responses: ", response1, response2, response3, response4);

            const response5 = await API.post('/reports/suitabilityReportFull',
                {
                    client,
                    resultPaths: [
                        response1.data.pathToReport,
                        response2.data.pathToReport,
                        response3.data.pathToReport,
                        response4.data.pathToReport,
                    ]
                }, config)

            console.log("response5: ", response5);

            return {
                success: true,
                body: response5,
            };



        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getRiskMarketReport(client, period, data, resolutionName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/riskMarketReport', {
                client,
                data,
                period,
                resolution_name: resolutionName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getRiskArticlesReport(client, period, data, pageIndex, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/riskArticlesReport', {
                client,
                data,
                period,
                pageIndex,
                endDate
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getRiskBenchmarksReport(client, period, data, pageIndex) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/riskBenchmarksReport', {
                client,
                data,
                period,
                pageIndex
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getRiskPolicyReport(client, period, data, resolutionName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/riskPolicyReport', {
                client,
                data,
                period,
                resolution_name: resolutionName
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFullRiskReport(client, resultPaths, resolutionName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/fullRiskReport', {
                client: client,
                resultPaths: resultPaths,
                resolutionName: resolutionName,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getCurveXMarketReport(data, capaFileName, period) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/reports/curveXMarket', {
                data,
                capaFileName,
                period,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getCostsReport(client, period, data, capaFileName) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            const response = await API.post('/reports/costsReport', {
                client,
                period,
                data,
                capaFileName,
            }, config)

            return {
                success: true,
                body: response
            };

        } catch (error) {
            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async deprecatedSaveChartTmpImage(clientId, data, index, fileName) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        };

        try {
            const response = await API.post('/reports/saveChartTmpImageDeprecated', {
                client_id: clientId,
                img_base64: data,
                index: index,
                file_name: fileName,
            }, config);

            return {
                success: true,
                body: response
            };
        } catch (error) {
            return {
                success: false,
                body: error.response.data
            };
        }
    },

    /**
     * @typedef {{
     *  chart: import('../controllers/ReportController').DataToReport['dataToChart'];
     *  maxValue?: number;
     * }} DataToReportAPI
     * @param {number} clientId
     * @param {DataToReportAPI} data
     * @param {number} count
     * @param {string} fileName
     * @typedef {'plEvolution' | 'distribuition' | 'comparative'} ReportTypeAPI
     * @param {ReportTypeAPI} reportType
     * @param {import('chart.js').ChartLegendOptions} legend
     * @returns
     */
    async saveChartTmpImage(
        clientId,
        data,
        count,
        fileName,
        reportType,
        legend
    ) {
        let config = {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        };

        try {
            const response = await API.post(
                "/reports/saveChartTmpImage",
                {
                    client_id: clientId,
                    data,
                    count,
                    file_name: fileName,
                    reportType,
                    legend,
                },
                config
            );

            return {
                success: true,
                body: response,
            };
        } catch (error) {
            console.log("Error: ", error);
            return {
                success: false,
                body: error.response.data,
            };
        }
    },

    async getBackofficeReport(month, year, statusIds, advisorId, consultingId, clientSearch, format = 'xlsx') {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
        }

        try {

            const response = await API.post('/reports/backofficeReport', {
                month,
                year,
                statusIds,
                advisorId,
                consultingId,
                clientSearch,
                format,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async getBackofficeReportHistory(year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/reports/backofficeReportHistory?year=' + (year || ''), config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async downloadBackofficeReport(reportId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
            responseType: 'blob',
        }

        try {

            const response = await API.get('/reports/downloadBackofficeReport?reportId=' + reportId, config)

            let fileName = 'relatorio_backoffice.xlsx';
            
            if (response.headers && response.headers['content-disposition']) {
                const contentDisposition = response.headers['content-disposition'];
                const matchFilename = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i) || contentDisposition.match(/filename=\"?([^"]+)\"?/i);
                if (matchFilename && matchFilename[1]) {
                    fileName = decodeURIComponent(matchFilename[1]);
                }
            }

            const contentType = response.headers && response.headers['content-type'];
            if (contentType && contentType.includes('pdf')) {
                if (!fileName.endsWith('.pdf')) {
                    fileName = fileName.replace(/\.[^/.]+$/, '') + '.pdf';
                }
            }

            return {
                success: true,
                body: {
                    blob: response.data,
                    fileName
                }
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },
}
